import React from 'react';
import { Flex, HStack, VStack } from '@televet/kibble-ui/build/chakra';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { ProfileErrorMessage, ProfileErrorTitle, useWidgetStore } from 'state/useWidgetStore';
import { Alert } from '@televet/kibble-ui/build/components/Alert';

const RequestTypeListContainer = ({ children }: { children: JSX.Element }): JSX.Element | null => {
  const {
    authentication: { hasNoPets, showAuthenticationAlert },
  } = useWidgetStore((state) => state);

  return (
    <Flex className="RequestTypeList__Container" flex="auto" overflow="auto" flexDir="column">
      <VStack
        className="RequestTypeList__Header"
        align="flex-start"
        bgColor="background.secondary"
        w="100%"
        pt={4}
        px={4}
        pb={5}
      >
        <HStack justify="space-between" w="100%">
          <Heading color="text.secondaryOnContrast">Common Requests</Heading>
        </HStack>
        {showAuthenticationAlert && (
          <Alert
            hideCloseButton
            status="warning"
            title={hasNoPets ? ProfileErrorTitle.HasNoPets : ProfileErrorTitle.HasNoProfile}
            description={hasNoPets ? ProfileErrorMessage.HasNoPets : ProfileErrorMessage.HasNoProfile}
          />
        )}
      </VStack>

      <Flex className="RequestTypeList__List" flexDir="column" align="stretch" mt={-6} pb={3} gap={3}>
        {children}
      </Flex>
    </Flex>
  );
};
export default RequestTypeListContainer;
